import {library} from '@fortawesome/fontawesome-svg-core';
import {faArrowLeft, faArrowRight, faCheck} from '@fortawesome/free-solid-svg-icons';

library.add(
  faArrowLeft,
  faArrowRight,
  faCheck,
);